module.exports = __webpack_public_path__ + "static/lp_investimentos_comunidade-625a2a72b8b58cdb500a05c570634020.png";